import { createSlice } from '@reduxjs/toolkit';

const loadUserFromLocalStorage = () => {
    try {
        const user = localStorage.getItem("user");
        return user ? JSON.parse(user) : null;
    } catch (error) {
        console.error("Error retrieving user: ", error);
        return null;
    }
}

const userSlice = createSlice({
    name: 'user',
    initialState: loadUserFromLocalStorage(),
    reducers: {
        setUserInfo: (state, { payload }) => {
            return payload;
        },
    }
});

export const {
    setUserInfo,
} = userSlice.actions;

export default userSlice.reducer;